/**
 * The one place a card-payment provider's name maps to what the POS may do with
 * it. Generalized code (CardReadService, the POS card handler) consults these
 * capabilities; the provider's own protocol lives in its native class under
 * capacitor-payment. Adding a provider = one row here plus its native class.
 */
export const CARD_PAYMENT_PROVIDERS = {
    payoneos: { sessionStrategy: 'server', supportsCancelReversal: false, supportsSettlement: false },
    nlb: { sessionStrategy: 'server', supportsCancelReversal: false, supportsSettlement: false },
    // APOS runs on the terminal itself: the session row is created on the device so a
    // sale works offline, and a completed sale is reversed with a void against its invoice.
    // It also supports an end-of-day settlement action (ECR "settlement" transaction) —
    // a one-way action that finalizes the terminal's batch (CardTerminalEndOfDay docs).
    payten: { sessionStrategy: 'local', supportsCancelReversal: true, supportsSettlement: true },
};
//# sourceMappingURL=CardPaymentProviders.js.map